import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const MDM_NUMBER_LENGTH = 20;

export const mdmNumberSchema = z
  .string()
  .regex(
    /^[a-zA-Z0-9]{1,20}$/,
    "Le n° MDM doit contenir au maximum 20 caractères alphanumériques",
  );

export const deleteNonVwfsLessorSchema = z.object({
  id: z.number(),
});

export const getNonVwfsLessorsRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addNonVwfsLessorSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  siret: z.string().regex(/^\d{14}/, "Le n° SIRET est incohérent"),
  mdmNumber: mdmNumberSchema,
});

export const editNonVwfsLessorSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  siret: z.string().regex(/^\d{14}/, "Le n° SIRET  est incohérent"),
  mdmNumber: mdmNumberSchema,
  isActive: z.boolean().default(true),
});
